import request from '@/utils/request'

export function findAgentsEsimProducts(params) {
  return request({
    url: `/agents_esim_products`,
    method: 'get',
    params
  })
}

export function importAgentsEsimProducts(data) {
  return request({
    url: `/agents_esim_products/import`,
    method: 'post',
    data
  })
}

export function findAgentsEsimProductForm(id) {
  return request({
    url: `/agents_esim_products/${id}/form`,
    method: 'get'
  })
}

export function updateAgentsEsimProduct(id, data) {
  return request({
    url: `/agents_esim_products/${id}`,
    method: 'put',
    data
  })
}

export function batchUpdateAgentsEsimProductsEffective(ids, effective) {
  return request({
    url: `/agents_esim_products/effective/batch`,
    method: 'patch',
    data: { ids, effective }
  })
}
